import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';

// interfaces/types
import type { UsabilityContext } from './usabilityTelemetry';

export const QUOTE_MODE_EVENTS = {
    modeEntered: 'MV:QuickQuote:ModeEntered',
    firstSave: 'MV:QuickQuote:FirstSave',
    vehicleConditionChanged: 'MV:QuickQuote:VehicleConditionChanged'
} as const;

export type QuoteModeEntrySource = 'initOrg' | 'initDealXg';

export type QuoteSaveOutcome = 'success' | 'failure';

export interface QuoteModeEnteredEventData {
    entrySource: QuoteModeEntrySource;
    hasDealXgRecord: boolean;
    quoteName: string;
    initialVehicleCondition: string;
    hasVehicle: boolean;
    dealershipCount: number;
}

export const trackQuoteModeEntered = (data: QuoteModeEnteredEventData, context: UsabilityContext): void => {
    logNewRelicPageAction(QUOTE_MODE_EVENTS.modeEntered, {
        entrySource: data.entrySource,
        hasDealXgRecord: data.hasDealXgRecord,
        quoteName: data.quoteName,
        initialVehicleCondition: data.initialVehicleCondition,
        hasVehicle: data.hasVehicle,
        dealershipCount: data.dealershipCount,
        ...context
    });
};

export interface QuoteFirstSaveEventData {
    outcome: QuoteSaveOutcome;
    isDraft: boolean;
    source?: string;
    hasVehicle: boolean;
    hasCustomer: boolean;
    durationMs?: number;
    errorMessage?: string;
    errorStatus?: number;
}

export const trackQuoteFirstSave = (data: QuoteFirstSaveEventData, context: UsabilityContext): void => {
    logNewRelicPageAction(QUOTE_MODE_EVENTS.firstSave, {
        outcome: data.outcome,
        isDraft: data.isDraft,
        hasVehicle: data.hasVehicle,
        hasCustomer: data.hasCustomer,
        ...(data.source ? { source: data.source } : {}),
        ...(typeof data.durationMs === 'number' ? { durationMs: data.durationMs } : {}),
        ...(data.errorMessage ? { errorMessage: data.errorMessage } : {}),
        ...(typeof data.errorStatus === 'number' ? { errorStatus: data.errorStatus } : {}),
        ...context
    });
};

export interface QuoteVehicleConditionChangedEventData {
    fromCondition: string;
    toCondition: string;
    changedFromDefault: boolean;
    hadVehicleBefore: boolean;
    triggerType: string;
    isPrimaryScope: boolean;
    scopeId?: string;
}

export const trackQuoteVehicleConditionChanged = (data: QuoteVehicleConditionChangedEventData, context: UsabilityContext): void => {
    logNewRelicPageAction(QUOTE_MODE_EVENTS.vehicleConditionChanged, {
        fromCondition: data.fromCondition,
        toCondition: data.toCondition,
        changedFromDefault: data.changedFromDefault,
        hadVehicleBefore: data.hadVehicleBefore,
        triggerType: data.triggerType,
        isPrimaryScope: data.isPrimaryScope,
        ...(data.scopeId ? { scopeId: data.scopeId } : {}),
        ...context
    });
};
